import axios from "axios";
import {INVALID_QRCODE} from './messages';
import moment from 'moment';

const isObjectEmpty = obj => JSON.stringify(obj) === '{}';
const isObject = data => Object.prototype.toString.call(data) === '[object Object]';
const getLocalItem = key => {
    try {
        const item = window.localStorage.getItem(`passion-care-${key}`);

        return item ? JSON.parse(item) : null;
    } catch (e) {
        return null;
    }
}
const setLocalItem = (key, value) => {
    try {
        window.localStorage.setItem(`passion-care-${key}`, JSON.stringify(value));
    } catch (e) {
        console.error(e);
    }
};
const removeLocalItem = key => {
    window.localStorage.removeItem(`passion-care-${key}`);
};
const removeLocalItems = keys => {
    for (const key of keys) {
        window.localStorage.removeItem(`passion-care-${key}`);
    }
};

const isDigitalMember = cards => {
    if (cards && cards.length) {
        if (cards.length > 1) {
            return false;
        }

        if (
            String(cards[0].cardCode).toLowerCase() === 'pcdm' ||
            String(cards[0].canNumber).substr(0, 4) === '2000' ||
            String(cards[0].canNumber).substr(0, 4) === '9900') {
            return true;
        }
    }

    return false;
};

const isDigitalCard = card => {
    return String(card.cardCode).toLowerCase() === 'pcdm' ||
        String(card.canNumber).substr(0, 4) === '2000' ||
        String(card.canNumber).substr(0, 4) === '9900';
};

const formatCards = cards => {
    const _cards = [];
    if (cards && cards.length) {
        for (let [index, card] of cards.entries()) {
            card.index = index;
            card.selected = false;
            if (card.canNumber)
                _cards.push(card);
            //Removed below code for GSIDEV-5294 Feedback
            // // Omit the digital card from the list
            // if (!isDigitalCard(card)) {
            // }
        }
    }

    return _cards;
};

const _waitFn = ms => {
    return new Promise(resolve => setTimeout(resolve, ms));
};

const invalidQR = (content) => {
    if (content) {
        const arrayOfObjects = [
            {EVENTNAME: content.title ? content.title : ""},
            {STARTDATE: content.startTime ? moment(content.startTime).format('yyyy-MM-DD HH:mm:ss') : ""},
            {ENDDATE: content.endTime ? moment(content.endTime).format('yyyy-MM-DD HH:mm:ss') : ""}
        ]
        return arrayOfObjects.reduce((f, s) => `${f}`.replace(Object.keys(s)[0], s[Object.keys(s)[0]]), INVALID_QRCODE)
    } else {
        return 'The PAssion CARES QR Code / Link is invalid or the session has expired. <br> Please scan the PAssion CARES QR again.<br>If the issue persists, please contact the organiser for assistance.';
    }
}

const retryFetch = (options, retries = 0) => {
    return axios(options)
        .then(res => res.data)
        .catch(async err => {
            if (err.response && err.response.data) {
                if (err.response.data.error && err.response.status < 500) {
                    // This is a normal error
                    return err.response.data;
                }
            }

            if (retries > 0) {
                await _waitFn(1500);

                return retryFetch(options, retries - 1);
            }

            return {
                hasError: true,
                errorMessages: 'We are having technical difficulties contacting the server. Please try again later.',
                cause: err.response && err.response.data ? err.response.data : 'error'
            };
        });
};

export {
    isObjectEmpty,
    isObject,
    getLocalItem,
    setLocalItem,
    removeLocalItem,
    removeLocalItems,
    retryFetch,
    formatCards,
    isDigitalMember,
    isDigitalCard,
    invalidQR
}
